"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filenameEncoding = exports.default = void 0;
var filenameEncoding = exports.filenameEncoding = function filenameEncoding() {
  if (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Edge') > -1) {
    return 'URL_ENCODE';
  }
  return 'MIME_UTILITY';
};
var _default = exports.default = filenameEncoding;